import React from 'react';

import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import { useUserContext } from '@/modules/auth/hooks/useUser';
import { SIDEBAR_LINE_FILL } from '@/modules/corporate/modules/admin/components/Sidebar/theme';
import KnowledgeBase from '@/modules/knowledge-base-copilot/entry';
import useKnowledgeBaseEnabled from '@/modules/knowledge-base-copilot/hooks/useKnowledgeBaseEnabled';

import NotificationBell from './NotificationBell';

const ActionDivider = () => (
  <div aria-hidden="true" className={cn('h-26 w-1 flex-shrink-0', SIDEBAR_LINE_FILL)} />
);

const UnifiedRightNode = () => {
  const user = useUserContext();
  const isCoachEnabled = useKnowledgeBaseEnabled();

  if (!user.id) {
    return null;
  }

  return (
    <Stack alignItems="center" gap={12}>
      <KnowledgeBase />
      {isCoachEnabled ? <ActionDivider /> : null}
      <NotificationBell />
    </Stack>
  );
};

export default React.memo(UnifiedRightNode);
